import { motion } from "framer-motion";
import {
  FLOW4_CHECKS,
  FLOW4_GOALS,
  PLAN_SUMMARY,
  READY_STATS,
  WEEK_PLAN,
  WEEK_PLAN_SHIFTED,
} from "../data/flow4Planning";
import {
  NEXT_GOALS,
  PARENT_SUMMARY,
  SUBJECT_TIME,
  WEEK_TASKS,
} from "../data/flow7Parent";

function Shell({ testId, title, subtitle, children, time }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      className="self-start max-w-[92%] overflow-hidden rounded-2xl rounded-tl-sm border border-[#C6EBD7] bg-white shadow-sm"
      data-testid={testId}
    >
      {(title || subtitle) && (
        <div className="bg-[#E9FBF0] px-3 py-2">
          {title && <div className="text-sm font-semibold text-[#122118]">{title}</div>}
          {subtitle && <div className="text-[11px] text-[#4a5f53]">{subtitle}</div>}
        </div>
      )}
      <div className="px-3 py-2.5">{children}</div>
      <div className="px-3 pb-2 text-right text-[10px] text-gray-500">{time}</div>
    </motion.div>
  );
}

export function GoalsCard({ time }) {
  return (
    <Shell testId="lab-goals-card" time={time}>
      <ul className="space-y-1.5 text-[12px] text-[#122118]">
        {FLOW4_GOALS.map(([subject, detail]) => (
          <li key={subject}>
            <span className="font-semibold">{subject}</span>
            <span className="text-[#4a5f53]"> — {detail}</span>
          </li>
        ))}
      </ul>
    </Shell>
  );
}

export function BuildCard({ time }) {
  return (
    <Shell testId="lab-build-card" time={time}>
      <ul className="space-y-1 text-[12px] text-[#122118]">
        {FLOW4_CHECKS.map((item) => (
          <li key={item}>✓ {item}</li>
        ))}
      </ul>
      <dl className="mt-2 space-y-1 border-t border-[#E5F6EC] pt-2 text-[12px]">
        {PLAN_SUMMARY.map(([label, value]) => (
          <div key={label} className="flex gap-2">
            <dt className="w-[5.5rem] shrink-0 text-[#829C8D]">{label}</dt>
            <dd className="font-semibold">{value}</dd>
          </div>
        ))}
      </dl>
    </Shell>
  );
}

export function WeekPlanCard({ time, modified = false }) {
  const rows = modified ? WEEK_PLAN_SHIFTED : WEEK_PLAN;
  return (
    <Shell testId="lab-week-card" title="Mon plan de la semaine" time={time}>
      <ul className="space-y-1.5 text-[12px] text-[#122118]">
        {rows.map(([day, subject, hours, length]) => (
          <li key={day}>
            <div className="font-semibold">{day}</div>
            <div className="text-[#4a5f53]">
              {subject} · {hours} · {length}
            </div>
          </li>
        ))}
      </ul>
      <div className="mt-2 border-t border-[#E5F6EC] pt-2 text-[12px] font-semibold text-[#0B8F6A]">
        Total : 5 h 30 d'étude · 6 séances
      </div>
    </Shell>
  );
}

export function ReadyPlanCard({ time }) {
  return (
    <Shell testId="lab-ready-card" title="C'est prêt !" time={time}>
      <ul className="space-y-1 text-[12px] font-semibold text-[#122118]">
        {READY_STATS.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </Shell>
  );
}

export function ParentSummaryCard({ time }) {
  return (
    <Shell testId="lab-parent-summary" title="Résumé de la semaine" time={time}>
      <ul className="space-y-1.5 text-[12px] font-semibold text-[#122118]">
        {PARENT_SUMMARY.map(([label, value]) => (
          <li key={label}>{value}</li>
        ))}
      </ul>
    </Shell>
  );
}

export function SubjectBarsCard({ time }) {
  return (
    <Shell testId="lab-subject-bars" title="Temps d'étude" time={time}>
      <ul className="space-y-2">
        {SUBJECT_TIME.map((item) => (
          <li key={item.label} className="text-[12px]">
            <div className="mb-0.5 flex justify-between font-semibold text-[#122118]">
              <span>{item.label}</span>
              <span>{item.time}</span>
            </div>
            <div className="h-1.5 overflow-hidden rounded-full bg-[#F0F4F2]">
              <div
                className="h-full rounded-full"
                style={{ width: item.width, background: item.color }}
              />
            </div>
          </li>
        ))}
      </ul>
    </Shell>
  );
}

export function TaskListCard({ time }) {
  return (
    <Shell testId="lab-task-list" title="5 sur 6" subtitle="activités réalisées · 83 %" time={time}>
      <ul className="space-y-1 text-[12px] text-[#122118]">
        {WEEK_TASKS.map((task) => (
          <li key={task.label} className={task.done ? "" : "text-[#829C8D]"}>
            {task.done ? "✓" : "○"} {task.label}
          </li>
        ))}
      </ul>
    </Shell>
  );
}

export function NextGoalsCard({ time }) {
  return (
    <Shell testId="lab-next-goals" title="Semaine du 16 – 22 oct." time={time}>
      <ul className="space-y-1 text-[12px] font-semibold text-[#122118]">
        {NEXT_GOALS.map((goal) => (
          <li key={goal}>{goal}</li>
        ))}
      </ul>
    </Shell>
  );
}
